import React, { act, createContext, useContext, useEffect, useState } from 'react';
import commonApi from '../utils/api';
import { useNavigate } from 'react-router-dom';
import { CommonContext } from './CommonContext';
import { format } from 'date-fns';

export const OrdersContext = createContext();

const initialFilters = {
    searchBy: 'awb_no',
    searchValue: '',
    merchant_id: [],
    status: '',
    courier_id: [],
    delivery_type_id: '',
    order_status_id: [1],
    dateRange: {
        startDate: new Date(),
        endDate: new Date()
    },
    tab_id: 1,
};
const tabOptions = [
    { label: "Today Uploads", value: 1 },
    { label: "Manifest", value: 2 },
    { label: "NDR", value: 4 },
    { label: "In Transit", value: 5 },
    { label: "Delivered", value: 8 },
    { label: "OFD", value: 7 },
    { label: "Returned to Seller", value: 12 },
    { label: "Booking Failed", value: 21 },
    { label: "All Shipped Orders", value: 99 }
];
export const OrdersContextProvider = ({ children }) => {
    const { user, alertMessage, setAlertMessage, openAlert, setOpenAlert, severity, setSeverity, globalSearch } = useContext(CommonContext);
    const navigate = useNavigate();

    const [filters, setFilters] = useState(initialFilters);
    const [activeTab, setActiveTab] = useState(tabOptions[0].value);
    const [addModal, setAddModal] = useState(false);
    const [osId, setOsId] = useState(1);
    const [isExportOpen, setIsExportOpen] = useState(false);
    const [selected, setSelected] = useState([]);
    const [allData, setAllData] = useState([]);
    const [allOrders, setAllOrders] = useState([]);
    const [firstLoading, setFirstLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [cancelDialog, setCancelDialog] = useState(false);
    const [cancelRemarks, setCancelRemarks] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [details, setDetails] = useState();
    const [isOpen, setIsOpen] = useState(false);
    const [openTracking, setOpenTracking] = useState(false);
    const [trackingInfo, setTrackingInfo] = useState(null);

    const handleAddModal = () => {
        setAddModal(true);
    };

    const handleCloseModal = () => {
        setAddModal(false);
    };
    const onCloseAlert = () => {
        setOpenAlert(false);
        setAlertMessage('');
        setSeverity('')
    };

    const handleToggleDrawer = () => {
        setIsOpen(!isOpen);
    };
    // console.log('filters', filters);
    const onLoadApi = (customFilters = filters) => {
        // debugger;
        const payload = {
            ...customFilters,
            start_date: customFilters?.dateRange?.startDate
                ? format(new Date(customFilters.dateRange.startDate), 'yyyy-MM-dd')
                : null,
            end_date: customFilters?.dateRange?.endDate
                ? format(new Date(customFilters.dateRange.endDate), 'yyyy-MM-dd')
                : null,
        };
        if (activeTab === 99) {
            payload.order_status_id = [];
        }

        // if (globalSearch?.value) {
        //     payload.searchBy = 'awb_no';
        //     payload.searchValue = globalSearch?.value;
        //     payload.start_date = '';
        //     payload.end_date = '';
        //     setFilters((prev) => ({ ...prev, order_status_id: [99], tab_id: 99, searchBy: 'awb_no', searchValue: globalSearch?.value, dateRange: { startDate: null, endDate: null } }));
        //     setActiveTab(99);
        // }

        delete payload.dateRange;
        setAllData([]);
        setAllOrders([]);
        setFirstLoading(false);
        commonApi.post(`/orders/list?page=${page + 1}&per_page=${rowsPerPage}`, payload)
            .then((response) => {
                setFirstLoading(true);
                if (response?.data?.data) {
                    setAllOrders(response?.data?.data);
                    setAllData(response?.data);
                }
            })
            .catch((error) => {
                setFirstLoading(true);
                console.error('Error fetching data:', error);
            });
    };
    const onTracking = (id) => {
        setOpenTracking(false);
        setTrackingInfo(null);
        setIsLoading(true);
        commonApi.post('/orders/tracking', { order_ids: id })
            .then((response) => {
                setIsLoading(false);
                if (response?.data?.s === 1) {
                    setOpenTracking(true);
                    setTrackingInfo(response?.data?.data)
                } else {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error');
                    setOpenAlert(true);
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth',
                    });
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
                setAlertMessage(error?.response?.data?.msg);
                setSeverity('error');
                setOpenAlert(true);
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
            });
    }
    const viewDetail = (id) => {
        setDetails(null);
        setIsLoading(true);
        commonApi.post('/orders/view', { id: id })
            .then((response) => {
                setIsLoading(false);
                if (response?.data?.s === 1) {
                    setDetails(response?.data?.data);
                    handleToggleDrawer();
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
            });
    }
    // Fetch initial data when the context is created
    useEffect(() => {
        const customFilters = { ...filters };
        if (globalSearch?.value) {
            customFilters.searchBy = 'awb_no';
            customFilters.searchValue = globalSearch?.value;
            customFilters.start_date = '';
            customFilters.end_date = '';
            customFilters.order_status_id = [];
            customFilters.tab_id = 99;
            customFilters.dateRange = { startDate: null, endDate: null };
            setFilters((prev) => ({ ...prev, order_status_id: [99], tab_id: 99, searchBy: 'awb_no', searchValue: globalSearch?.value, dateRange: { startDate: null, endDate: null } }));
            setActiveTab(99);
        }
        onLoadApi(customFilters);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, rowsPerPage, activeTab, globalSearch?.searchTrigger]);

    const onCancelOrder = () => {
        setIsLoading(true);
        commonApi.post('/orders/cancel-orders', { "order_ids": selected.join(', '), "remarks": cancelRemarks })
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('success');
                    setCancelRemarks('');
                    setSelected([]);
                    setCancelDialog(false);
                    onLoadApi();
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setOpenAlert(true);
                setAlertMessage(error.response?.data?.msg);
                setSeverity('error')
                console.error('Error fetching data:', error);
            });
    };
    const recheckStatus = () => {
        setIsLoading(true);
        commonApi.post('/cron/tracking', { "order_ids": selected.join(', ') })
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('success');
                    setCancelRemarks('');
                    setSelected([]);
                    setCancelDialog(false);
                    onLoadApi();
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setOpenAlert(true);
                setAlertMessage(error.response?.data?.msg);
                setSeverity('error')
                console.error('Error fetching data:', error);
            });
    };
    const onLabelGen = () => {
        setIsLoading(true);
        commonApi.post('/orders/generate-address-labels', { "order_ids": selected.join(', ') })
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('success');
                    setSelected([]);
                    onLoadApi();
                    setTimeout(() => {
                        navigate('/download');
                    }, 3000);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
            });
    };
    const onBulkPOD = () => {
        setIsLoading(true);
        commonApi.post('/orders/generate-bulk-pod', { "order_ids": selected.join(', ') })
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('success');
                    setSelected([]);
                    onLoadApi();
                    setTimeout(() => {
                        navigate('/download');
                    }, 3000);
                }
            })
            .catch((error) => {
                setAlertMessage(error?.response?.data?.msg || error?.message || 'Something went wrong');
                setOpenAlert(true);
                setSeverity('error');
                setIsLoading(false);
                console.error('Error fetching data:', error);
            });
    };
    const onInvoiceGen = () => {
        setIsLoading(true);
        commonApi.post('/orders/generate-product-invoices', { "order_ids": selected.join(', ') })
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('success');
                    setSelected([]);
                    onLoadApi();
                    setTimeout(() => {
                        navigate('/download');
                    }, 3000);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
            });
    };
    const onManifestGen = () => {
        setIsLoading(true);
        commonApi.post('/orders/generate-manifest', { "order_ids": selected.join(', ') })
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('success');
                    setSelected([]);
                    onLoadApi();
                    setTimeout(() => {
                        navigate('/download');
                    }, 3000);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
            });
    };
    const downLoadPod = (id) => {
        setIsLoading(true);
        commonApi.post('/orders/generate-epod', { "order_ids": id })
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('success');
                    // setSelected([]);
                    // onLoadApi();
                    setTimeout(() => {
                        navigate('/download');
                    }, 3000);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
            });
    };
    const onShip = () => {
        setIsLoading(true);
        commonApi.post('/orders/ship', { "order_ids": selected.join(', ') })
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('success');
                    setSelected([]);
                    onLoadApi();
                    // handleOpenShipModal();
                    // setShippingData(response?.data?.allREsponse);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
            });
    };
    const onExport = (columns) => {
        let payload = {
            ...filters,
            start_date: filters?.dateRange?.startDate
                ? format(new Date(filters.dateRange.startDate), 'yyyy-MM-dd')
                : null,
            end_date: filters?.dateRange?.endDate
                ? format(new Date(filters.dateRange.endDate), 'yyyy-MM-dd')
                : null,
        };
        if (user?.user_type !== "Merchant") {
            payload.admin_id = user?.id
        }
        if (selected.length > 0) {
            payload.order_ids = selected.join(', ')
        }
        payload.tab_id = osId
        if (columns?.length) payload.columns = columns

        delete payload.dateRange;
        setIsLoading(true);
        commonApi.post('/orders/export', payload)
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    navigate('/download');
                    setIsExportOpen(false);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
                setOpenAlert(true);
                setAlertMessage(error?.response?.data?.msg);
                setSeverity('error')
            });
    };

    const onCalling = (row) => {
        setIsLoading(true);
        const postReq = { order_id: row.id ?? '', awb_no: row.awb_no ?? '', customer_mobile: row.customer_mobile ?? '', ivr_mobile: user?.ivr_mobile ?? '' }
        commonApi.post('ivr/clickToCall', postReq)
            .then((response) => {
                setIsLoading(false);
                if (response?.data?.s === 1) {
                    setOpenAlert(true);
                    setAlertMessage(response?.data?.msg);
                    setSeverity('success');
                } else {
                    setOpenAlert(true);
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error');
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setOpenAlert(true);
                setAlertMessage(error?.res?.data?.msg);
                setSeverity('error');
            });
    };

    const contextValue = {
        onCalling,
        addModal,
        handleAddModal,
        handleCloseModal,
        trackingInfo,
        openTracking,
        setOpenTracking,
        onTracking,
        isOpen,
        setIsOpen,
        handleToggleDrawer,
        viewDetail,
        details,
        initialFilters,
        osId,
        setOsId,
        allData,
        setAllData,
        allOrders,
        setAllOrders,
        page,
        setPage,
        rowsPerPage,
        setRowsPerPage,
        firstLoading,
        setFirstLoading,
        cancelDialog,
        setCancelDialog,
        isLoading,
        setIsLoading,
        onLoadApi,
        selected,
        setSelected,
        tabOptions,
        activeTab,
        setActiveTab,
        filters,
        setFilters,
        onCancelOrder,
        onExport,
        isExportOpen,
        setIsExportOpen,
        recheckStatus,
        downLoadPod,
        onManifestGen,
        onInvoiceGen,
        onLabelGen,
        onBulkPOD,
        onShip,
    };
    return (
        <OrdersContext.Provider value={contextValue}>
            {children}
        </OrdersContext.Provider>
    );
};

